import { Controller } from "stimulus"
import consumer from '../channels/consumer'

export default class extends Controller {
  static targets = [ "configurationLoading", "configurationSection" ]
 
  connect() {
    let integrationSetupController = this;

    this.channel = consumer.subscriptions.create({ channel: "IntegrationDataChannel", integration: this.data.get('integration')}, {
      connected() {
        this.perform("load_configuration", {integration: integrationSetupController.data.get('integration')});
      },

      disconnected() {
      },

      received(config) {
        if (config.configuration_loaded) {
          let loading = integrationSetupController.configurationLoadingTarget
          if (config.error) {
            loading.querySelector('img').classList.add('hidden')
            loading.querySelector('p').classList.add('text-red-500')
            loading.querySelector('p').innerText = `Error loading configuration: ${config.error}`
          }
          else {
            integrationSetupController.loadConfiguration()
          }
        }
      }
    })

  }

  disconnect() {
    if (this.channel) {
      this.channel.unsubscribe()
      this.channel = null
    }
  }

  loadConfiguration() {
    let url = this.data.get('configureUrl')
    fetch(url)
    .then(response => response.text())
    .then(html => {
      this.configurationSectionTarget.classList.remove(...this.configurationSectionTarget.classList)
      this.configurationSectionTarget.innerHTML = html
      this.configurationLoadingTarget.classList.add('hidden')
    })
  }
}
